import { reactive } from 'vue';

export const criarEpAi = () => {
    return reactive({
        id: 0,
        idep: 0,
        cdai: 0,
        nmai: '',
        instrucoes: '',
        ativo: 'S',
        tpproduto_mapa: '',
        idlogin: 0,
    });
}
